import { Link } from "react-router-dom";
import { createDealerDirectoryInboundNavHandler } from "../../utils/dealerDirectory/dealerDirectoryAnalytics";
import { DEALER_DIRECTORY_ANALYTICS_SOURCE_COMPONENTS } from "../../constants/dealerDirectoryAnalyticsConstants";

const trackDirectoryFromHomepage = createDealerDirectoryInboundNavHandler(
  DEALER_DIRECTORY_ANALYTICS_SOURCE_COMPONENTS.HOMEPAGE,
  { destinationPath: "/concesionarios" }
);

export default function LaunchLandingPage() {
  return (
    <div className="midpoint-app" style={{ maxWidth: 960, margin: "0 auto", padding: "2rem 1rem" }}>
      <header style={{ marginBottom: "2rem" }}>
        <p className="eyebrow">AutoMapa · Medellín</p>
        <h1>Encuentra carros usados en Medellín con más confianza</h1>
        <p className="muted">
          Compara opciones, revisa señales de precio y riesgo, y contacta concesionarios verificados por WhatsApp.
        </p>
      </header>
      <section style={{ display: "flex", flexWrap: "wrap", gap: "0.75rem", marginBottom: "2rem" }}>
        <Link className="dealer-portal-btn" to="/v/automap/vehicles">
          Buscar carros usados
        </Link>
        <Link className="dealer-portal-btn" to="/comprar/quiz">
          Quiz: encuentra tu carro
        </Link>
        <Link className="dealer-portal-btn" to="/checklist-compra">
          Checklist de compra
        </Link>
        <Link className="dealer-portal-btn" to="/concesionarios" onClick={trackDirectoryFromHomepage}>
          Ver concesionarios
        </Link>
        <Link className="dealer-portal-btn" to="/carros-usados-medellin">
          Carros usados Medellín
        </Link>
      </section>
      <section className="dealer-state-box">
        <h2>¿Por qué AutoMapa?</h2>
        <ul>
          <li>Concesionarios verificados en el área metropolitana</li>
          <li>Señales de precio justo y riesgo del vehículo</li>
          <li>Contacto directo por WhatsApp desde cada publicación</li>
          <li>Guías y checklist para comprar con más seguridad</li>
        </ul>
      </section>
      <section className="dealer-state-box">
        <h2>Búsquedas populares</h2>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
          <Link to="/camionetas-usadas-medellin">Camionetas usadas</Link>
          <Link to="/carros-financiados-medellin">Carros financiados</Link>
          <Link to="/carros-automaticos-medellin">Carros automáticos</Link>
        </div>
      </section>
    </div>
  );
}
